import { HStack, IconButton, Tooltip } from '@chakra-ui/react';
import { MdFileCopy } from 'react-icons/md';
import { setFormattedValue } from 'utils/utils';

import Text from 'components/v4/Text';
import { iconStyling } from './agGridStyles';
import useCellHover from '../AGGrid/hooks/useCellHover';

const NumberRangeCellRenderer = ({ value, ...params }) => {
    const currentRow = params.data;
    const formattedValue = setFormattedValue(currentRow);
    const { isHovered, containerRef } = useCellHover();
    return (
        <HStack ref={containerRef} width="100%">
            <Text isTruncated>{formattedValue}</Text>
            {isHovered && (
                <Tooltip label="Copy to clipboard">
                    <IconButton
                        sx={iconStyling}
                        size="sm"
                        variant="ghost"
                        onClick={(e) => {
                            e.stopPropagation();
                            navigator.clipboard.writeText(value);
                        }}>
                        <MdFileCopy />
                    </IconButton>
                </Tooltip>
            )}
        </HStack>
    );
};

export default NumberRangeCellRenderer;
